// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"BreadCrumbs_breadcrumb__6MVhV","average-salary-text":"BreadCrumbs_average-salary-text__q_wa4"};